var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { AMSTopValue } from "../constants/Common.constants.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const getErrorMessage = (result) => {
  var _a;
  if (200 !== result.statusCode) {
    return (_a = result.errorContext) == null ? void 0 : _a.displayError;
  } else {
    return "";
  }
};
let AuthenticationResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.ams);
  }
  getServicePrincipalNameList(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/authentication?includeSucceededOnly=true&includeOwnedOnly=true&top=${AMSTopValue}`;
      const result = yield this._get(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
  getManagedIdentityNameList(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/managed-identity`;
      const result = yield this._get(address);
      result.error = getErrorMessage(result);
      return result;
    });
  }
};
AuthenticationResource = __decorateClass([
  WPSProxyConverter()
], AuthenticationResource);
const AuthenticationResources = new AuthenticationResource();
export {
  AuthenticationResources as default
};
//# sourceMappingURL=AuthenticationResources.js.map
